<template>
  <div class="application application_request application_large" @click.stop>
    <div class="main-modal__title" v-text="$t('request.newHeader')"></div>
    <div ref="hidden_helper"></div>

    <form @submit.prevent="confirm" class="main-form" autocomplete="nope_">
      <div class="application__body">
        <div class="application-left">
          <!--  USER BASE INFO START [name, surname, email, phone]-->
          <div class="application-box mb16">
            <div class="application-box__title">Kunde:</div>

            <vue-tel-input
              v-model="contact.phone"
              :placeholder="$t('forms.phone')"
              :inputOptions="{ showDialCode: true }"
              :defaultCountry="defaultCountry"
              mode="international"
              class="main-vue-tel-input"
              @validate="checkValue"
              @blur="onPhoneTypingFinish"
            ></vue-tel-input>
          </div>

          <div class="application-box mb16">
            <input
              type="text"
              class="main-form__input"
              v-validate="'required'"
              data-vv-as="field"
              name="email"
              placeholder="Email"
              v-model="contact.email"
              :disabled="!isPhoneEntered"
            />
          </div>

          <div class="application-box mb16">
            <input
              type="text"
              class="main-form__input"
              v-model="contact.first_name"
              v-validate="'required'"
              data-vv-as="field"
              name="first_name"
              :placeholder="$t('forms.name')"
              :disabled="!isPhoneEntered"
            />
          </div>

          <div class="application-box mb16">
            <input
              type="text"
              class="main-form__input"
              v-model="contact.last_name"
              v-validate="'required'"
              data-vv-as="field"
              name="last_name"
              :placeholder="$t('forms.surname')"
              :disabled="!isPhoneEntered"
            />
          </div>
          <!--  USER BASE INFO END [name, surname, email, phone]-->

          <!--  USER HOUSE INFO START-->

          <div class="application-box mb16">
            <div class="application-box__title">ADRESSE:</div>
            <div @click="openAutocomplete" class="el-input">
              <input
                name="street"
                :placeholder="$t('forms.street')"
                :value="autocompleteValue"
                class="main-form__input"
                :class="{
                  'input-disabled': !isPhoneEntered,
                }"
                 :disabled="!isPhoneEntered"
              />
            </div>
          </div>

          <div class="application-box mb16">
            <input
              type="text"
              class="main-form__input"
              v-model="formData.address.apartment"
              name="office"
              :placeholder="'Apt. /Büro'"
              :disabled="!isPhoneEntered"
            />
          </div>
          <!--  USER HOUSE INFO END-->

          <div class="application-box mb16">
            <div class="application-box__title">Problem:</div>

            <textarea
              class="main-form__textarea"
              v-model="formData.description"
              type="textarea"
              :autosize="{ minRows: 2, maxRows: 4 }"
              :placeholder="'Problem beschreiben'"
              :disabled="!isPhoneEntered"
            ></textarea>
          </div>

          <div class="application-box mb16">
            <div v-if="formData.images" class="application-info__client-media">
              <div v-for="(item, index) in formData.images" :key="`${item}${index}`">
                <img :src="item" width="100px" alt class />
              </div>
            </div>

            <div class="application-info__media">
              <div class="application-info__media-items">
                <div
                  class="application-info__media-item"
                  v-for="(item, index) in madiaData"
                  :key="item.id"
                  @click="deleteMedia(index)"
                >
                  <img :src="item" alt />
                </div>
              </div>
              <label
                class="application-info__media-add"
                :class="{ disabled: madiaData.length === 4 }"
              >
                <input type="file" @change="addMedia" v-if="madiaData.length < 4" />
                <img src="/images/icon/empty__small.svg" alt />
                <span>{{ $t("request.mediaButton") }}</span>
              </label>
            </div>
          </div>
        </div>

        <div class="application-right">
          <div class="application-box mb16">
            <div class="application-box__title">DETAILS:</div>

            <el-select
              v-model="formData.status"
              filterable
              placeholder="Select"
              class="mb16 select2-container_w100"
              style="width:100%"
            >
              <el-option
                v-for="(item, index) in statusesModified"
                :key="index"
                :label="item.value"
                :value="item.status"
              ></el-option>
            </el-select>

            <Select2
              v-validate="'required'"
              data-vv-as="field"
              name="services"
              :options="services"
              :settings="selectSettingServices"
              v-model="formData.service_id"
              class="select2-container_w100"
              @change="changeService"
            />
          </div>

          <div class="application-box mb16">
            <Select2
              v-model="formData.office_id"
              :options="filteredList"
              class="select select2-container_w100"
              :settings="selectSetting"
              placeholder="Office"
              @change="changeOffice"
            />
          </div>

          <div class="application-box mb16">
            <div class="application-userinfo__full mb8">
              <label for="isMultipleCheckbox" class="is-single-request">
                <input
                  id="isMultipleCheckbox"
                  type="checkbox"
                  :disabled="!isPhoneEntered"
                  @click="toggleRequestType"
                />

                <span class="is-single-request__title">{{ $t("forms.isMultipleOrder") }}</span>
              </label>
            </div>
          </div>

          <div class="application-box mb16">
            <el-date-picker
              v-if="!isMultipleRequest"
              class="multiple-days"
              v-model="formData.date"
              type="datetime"
              :placeholder="$t('request.dateHolder')"
              default-time="12:00:00"
              @blur="onBlur"
              @focus="onFocus"
              :pickerOptions="pickerOptions"
              :disabled="!isPhoneEntered"
              ref="datetime-picker-day"
              :editable="false"
              style="width:100%"
              @change="changeDate"
            ></el-date-picker>

            <el-date-picker
              style="width:100%"
              v-if="isMultipleRequest"
              class="multiple-days"
              type="dates"
              v-model="formData.days"
              :placeholder="$t('request.dateHolder')"
              :disabled="!isPhoneEntered"
              @blur="onBlur"
            ></el-date-picker>
          </div>

          <div class="application-box mb16">
            <el-time-select
              style="width:100%"
              v-validate="'required'"
              data-vv-as="field"
              name="predicted"
              class="application-time-picker"
              v-model="formData.duration"
              @change="calculatePrice"
              :picker-options="{
                start: '00:30',
                end: '10:00',
                step: '00:15',
              }"
              :placeholder="$t('request.requestTime')"
              :disabled="!isPhoneEntered || isMultipleRequest"
              :editable="false"
            ></el-time-select>
          </div>

          <div class="application-box mb16">
            <input
              type="text"
              class="main-form__input"
              v-validate="'required'"
              data-vv-as="field"
              name="final_price"
              placeholder="0"
              :value="recomendedFinalPrice"
              :disabled="!isPhoneEntered"
              clearable
              @change="onPriceChanged($event)"
            />
          </div>

          <div class="application-box mb16">
            <!-- <input
              type="text"
              class="main-form__input"
              v-validate="'required'"
              data-vv-as="field"
              name="final_price"
              placeholder="Discount %"
              v-model.lazy="discount"
              :disabled="!isPhoneEntered"
              clearable
              maxlength="2"
            />-->

            <input
              class="main-form__input"
              type="text"
              :disabled="!isPhoneEntered"
              :value="formatDiscount"
              @change="onDiscountChange"
              placeholder="Discount %"
              maxlength="2"
            />
          </div>

          <div class="application-box mb16">
            <div class="application-userinfo__full mb8">
              <label for="isMyHammer" class="is-single-request">
                <input
                  id="isMyHammer"
                  type="checkbox"
                  :disabled="!isPhoneEntered"
                  v-model="isMyHammer"
                />

                <span class="is-single-request__title">Ist ein Myhammer?</span>
              </label>
            </div>
          </div>

          <div class="application-box mb16">
            <input
              type="text"
              class="main-form__input"
              v-model="formData.my_hammer"
              :disabled="!isPhoneEntered"
              width="100%"
              :placeholder="$t('forms.orderUniqueId')"
            />
          </div>

          <div class="application-box mb16">
            <div class="application-box__title">KOMMENTAR:</div>

            <div class="input-group">
              <textarea
                class="main-form__textarea"
                v-model="formData.comment"
                type="textarea"
                :autosize="{ minRows: 2, maxRows: 4 }"
                :disabled="!isPhoneEntered"
              ></textarea>
            </div>
          </div>
        </div>
      </div>

      <div class="application-box">
        <div class="application-box__title application-box__title_flex">
          Tags
          <svg
            style="cursor:pointer"
            @click="openTagsModal"
            width="16"
            height="16"
            viewBox="0 0 16 16"
            fill="none"
            xmlns="http://www.w3.org/2000/svg"
          >
            <circle cx="8" cy="8" r="7.5" stroke="var(--menu-text-color)" />
            <path
              d="M8.00012 4.66669V11.3334"
              stroke="var(--menu-text-color)"
              stroke-linecap="round"
              stroke-linejoin="round"
            />
            <path
              d="M11.3332 8H4.6665"
              stroke="var(--menu-text-color)"
              stroke-linecap="round"
              stroke-linejoin="round"
            />
          </svg>
        </div>
        <div class="application-employee__block" v-if="tags.length > 0">
          <div class="main-form__box tags">
            <div
              :ref="`tag_${item.id}`"
              class="tag tag_active tag_mr32"
              v-for="item in tags"
              :key="item.id"
            >
              <svg
                v-if="item.can_use_scooter"
                width="15"
                height="15"
                viewBox="0 0 25 22"
                fill="none"
                xmlns="http://www.w3.org/2000/svg"
                style="margin-right: 8px"
              >
                <path
                  d="M16.5906 3.45675C17.269 3.45675 17.8189 2.9068 17.8189 2.22841C17.8189 1.55001 17.269 1.00006 16.5906 1.00006C15.9122 1.00006 15.3622 1.55001 15.3622 2.22841C15.3622 2.9068 15.9122 3.45675 16.5906 3.45675Z"
                  stroke="#0C0C0C"
                  stroke-width="1.4"
                  stroke-miterlimit="10"
                  stroke-linecap="round"
                  stroke-linejoin="round"
                />
                <path
                  d="M3.74017 18.2914H20.937"
                  stroke="#0C0C0C"
                  stroke-width="1.4"
                  stroke-miterlimit="10"
                  stroke-linecap="round"
                  stroke-linejoin="round"
                />
                <path
                  d="M17.3465 5.53552L16.2126 6.95285L17.8189 14.3229H19.2363"
                  stroke="#0C0C0C"
                  stroke-width="1.4"
                  stroke-miterlimit="10"
                  stroke-linecap="round"
                  stroke-linejoin="round"
                />
                <path
                  d="M12.5276 5.81897H8.55908"
                  stroke="#0C0C0C"
                  stroke-width="1.4"
                  stroke-miterlimit="10"
                  stroke-linecap="round"
                  stroke-linejoin="round"
                />
                <path
                  d="M9.78742 9.22052H3.74017"
                  stroke="#0C0C0C"
                  stroke-width="1.4"
                  stroke-miterlimit="10"
                  stroke-linecap="round"
                  stroke-linejoin="round"
                />
                <path
                  d="M13.945 12.4331H7.42529"
                  stroke="#0C0C0C"
                  stroke-width="1.4"
                  stroke-miterlimit="10"
                  stroke-linecap="round"
                  stroke-linejoin="round"
                />
                <path
                  d="M20.9371 21.0315C22.4504 21.0315 23.6772 19.8047 23.6772 18.2914C23.6772 16.778 22.4504 15.5512 20.9371 15.5512C19.4237 15.5512 18.1969 16.778 18.1969 18.2914C18.1969 19.8047 19.4237 21.0315 20.9371 21.0315Z"
                  stroke="#0C0C0C"
                  stroke-width="1.4"
                  stroke-miterlimit="10"
                  stroke-linecap="round"
                  stroke-linejoin="round"
                />
                <path
                  d="M3.74016 21.0315C5.2535 21.0315 6.48032 19.8047 6.48032 18.2914C6.48032 16.778 5.2535 15.5512 3.74016 15.5512C2.22681 15.5512 1 16.778 1 18.2914C1 19.8047 2.22681 21.0315 3.74016 21.0315Z"
                  stroke="#0C0C0C"
                  stroke-width="1.4"
                  stroke-miterlimit="10"
                  stroke-linecap="round"
                  stroke-linejoin="round"
                />
                <path
                  d="M17.063 3.26776L20.0866 15.6457"
                  stroke="#0C0C0C"
                  stroke-width="1.4"
                  stroke-miterlimit="10"
                  stroke-linecap="round"
                  stroke-linejoin="round"
                />
              </svg>
              {{ item.name }}
              <span class="tag__close" @click="removeTag(item.id)">
                <svg
                  width="12"
                  height="12"
                  viewBox="0 0 22 22"
                  fill="none"
                  xmlns="http://www.w3.org/2000/svg"
                >
                  <path
                    fill-rule="evenodd"
                    clip-rule="evenodd"
                    d="M16.9703 5.70725C17.3612 5.31725 17.3612 4.68325 16.9703 4.29325C16.5802 3.90225 15.9472 3.90225 15.5562 4.29325L10.6322 9.21725L5.70725 4.29325C5.31725 3.90225 4.68325 3.90225 4.29325 4.29325C3.90225 4.68325 3.90225 5.31725 4.29325 5.70725L9.21725 10.6322L4.29325 15.5562C3.90225 15.9472 3.90225 16.5802 4.29325 16.9703C4.68325 17.3612 5.31725 17.3612 5.70725 16.9703L10.6322 12.0463L15.5562 16.9703C15.9472 17.3612 16.5802 17.3612 16.9703 16.9703C17.3612 16.5802 17.3612 15.9472 16.9703 15.5562L12.0463 10.6322L16.9703 5.70725Z"
                    fill="var(--menu-text-color)"
                  />
                </svg>
              </span>
            </div>
          </div>
        </div>
      </div>

      <order-executors
        :service_id="formData.service_id"
        :office_id="formData.office_id"
        :address="formData.address"
        :duration="duration"
        :date="formData.date"
        :responsible="responsible"
        :tags="tags"
        :isSingle="!isMultipleRequest"
        @onConfirmResponsible="onConfirmResponsible"
        @onRemoveResponsible="onRemoveResponsible"
      />

      <div class="main-form__buttons main-form__buttons_center">
        <button type="reset" @click="$emit('close')" class="main-button main-button_cancel">
          <span>{{ $t("global.cancel") }}</span>
        </button>

        <button
          class="main-button"
          type="submit"
          :class="{
            disabled: !isValid || disableButton,
          }"
          :disabled="!isValid || disableButton"
        >
          <span>{{ $t("request.addRequest") }}</span>
        </button>
      </div>
    </form>

    <modal :show="error" :dark="true" @close="closeModalError">
      <error-modal :okAction="closeModalError">{{ $t("request.errorMedia") }}</error-modal>
    </modal>

    <modal :show="showAutocomplete" :showBtn="false" :dark="true" @close="toggleAutocomplete">
      <autocomplete
        :autocompleteValue="autocompleteValue"
        @done="fillAddress"
        @close="toggleAutocomplete"
      />
    </modal>

    <modal :show="isTagsShow" :dark="true" :outside="false" @close="closeTagsModal">
      <tags-modal :tags="tags" @close="closeTagsModal" @done="addTags" />
    </modal>
  </div>
</template>
<script>
import { mapActions, mapGetters, mapMutations } from 'vuex'
import moment from 'moment'
import autocomplete from '@/components/controls/autocomplete'
import recomendedPrice from '@/mixins/recomendedPrice'
import tagsModal from '@/components/modals/tags/tagsToOrder'
import availableDateMixin from '@/mixins/availableDate'
import orderExecutors from '@/components/modals/orders/ordersExecutors'

export default {
    name: 'request-add-modal',
    mixins: [recomendedPrice, availableDateMixin],
    components: {
        autocomplete,
        tagsModal,
        orderExecutors,
    },
    data() {
        return {
            madiaData: [],
            formMediaData: [],
            showModalAddresponsible: false,
            responsible: [],
            error: false,
            comment: '',
            clients: {},
            minDatetime: moment(moment()).toISOString(),
            maxDatetime: moment()
                .add(3, 'months')
                .toISOString(),
            selectSettingServices: {
                placeholder: this.$t('navigation.services'),
                allowClear: false,
            },
            selectSetting: {
                placeholder: 'Office',
            },
            days: [],
            search: '',
            autocompleteValue: '',
            isValidPhone: false,
            disableButton: false,
            defaultCountry: this.$config.behavior === 'hilfy' ? 'at' : 'de',
            isMultipleRequest: false,
            isOpenqDateModal: true,
            datePickerBlurred: false,
            selectableRange: ['00:00:00 - 23:00:00'],
            isPhoneEntered: false,
            isRequestSent: false,

            service: null,
            isMyHammer: false,
            isTagsShow: false,
            tags: [],
            office_id: null,
            service_id: null,
            duration: null,
            statusesModified: null,
            discount: 0,
        }
    },
    computed: {
        ...mapGetters({
            services: 'servicesGetters',
            servicesFullData: 'servicesFullData',
            contact: 'requests/contactGetter',
            description: 'requests/descriptionGetters',
            formData: 'requests/formDataGetters',
            serverErrors: 'getServerErrors',
            showAutocomplete: 'autocomplete/showGetters',
            masks: 'masksGetters',
            extraPrices: 'orders/extraPrices',
            filteredList: 'offices/filteredList',
            statusesGetters: 'orders/statusesGetters',
        }),
        // mutatedRecomendedFinalPrice: {
        //   get() {
        //     return this.recomendedFinalPrice;
        //   },
        //   set(v) {
        //     this.setPriceByKey("_15", 0);
        //     this.setPriceByKey("hours", parseFloat(v));
        //     this.setPriceByKey("recomended", 1);
        //   }
        // },
        isValid() {
            if (this.isMultipleRequest && this.formData.days.length === 0) {
                return false
            }

            if (!this.isMultipleRequest && !!this.formData.date === false) {
                return false
            }

            if (
                (this.contact.first_name === '' || this.contact.first_name === null)
        && this.formData.client_id === null
            ) {
                return false
            }

            if (
                (this.contact.last_name === '' || this.contact.last_name === null)
        && this.formData.client_id === null
            ) {
                return false
            }

            if (
                (this.contact.email === '' || this.contact.email === null)
        && this.formData.client_id === null
            ) {
                return false
            }

            if (
                this.formData.address.street === ''
        || this.formData.address.street === null
            ) {
                return false
            }

            if (
                this.formData.address.house === ''
        || this.formData.address.house === null
            ) {
                return false
            }

            if (this.formData.service_id === '' || this.formData.service_id === null) {
                return false
            }

            if (this.recomendedFinalPrice === 0) {
                return false
            }

            if (
                this.formData.duration === ''
        || this.formData.duration === null
        || this.formData.duration === 0
            ) {
                return false
            }

            if (
                this.formData.status === 'confirmed'
        && this.responsible.length === 0
            ) {
                return false
            }

            return this.isValidPhone
        },
        pickerOptions() {
            return {
                firstDayOfWeek: 1,
                selectableRange: ['00:00:00 - 23:00:00'],
                disabledDate: (time) => {
                    const hasMatch = this.availableDays.find((date) => {
                        const localDate = new Date(date)
                        localDate.setHours(0, 0, 0, 0)
                        return localDate.getTime() === time.getTime()
                    })

                    if (!hasMatch) {
                        return true
                    }
                },
            }
        },
        formatDiscount() {
            if (!this.discount) return 0

            return Math.round(this.discount)
        },
    },
    watch: {
        discount(v) {
            const localDiscount = v > 0 ? v / 100 : 0
            this.setPriceByKey('discount', localDiscount)
        },
    },
    methods: {
        ...mapMutations({
            setContact: 'requests/setContact',
            toggleShowModalAdd: 'requests/toggleShowModalAdd',
            closeShowModalAdd: 'requests/closeShowModalAdd',
            setDefaultForm: 'requests/setDefaultForm',
            setDescription: 'requests/setDescription',
            setUpdateCalendar: 'setUpdateCalendar',
            toggleAutocomplete: 'autocomplete/toggleShow',
            clearLandingRequests: 'clearLandingRequests',
            clearOrders: 'orders/clearOrders',
            clearParams: 'orders/clearParams',
            setSnackbarShow: 'orders/setSnackbarShow',
            setSnackbarData: 'orders/setSnackbarData',
            setFormData: 'requests/setFormData',
        }),
        ...mapActions({
            addApplication: 'addApplication',
            getCalendarsData: 'getCalendarsData',
            getAdminRequests: 'getAdminRequests',
            ordersFetch: 'orders/fetch',
            getClientsData: 'getClientsData',
            fetchExtraPrice: 'orders/fetchExtraPrice',
            fetchWithSavingScrollState: 'orders/fetchWithSavingScrollState',
            fetchStatuses: 'orders/fetchStatuses',
        }),
        // onDiscountChange(event) {
        //   const v = +event.target.value;
        //   this.discount = v;

        //   if (this.discount == 0) {
        //     this.setPriceByKey("default", this.price.servicePrice);
        //     return;
        //   }

        //   const price = this.price.servicePrice * (1 - this.discount / 100);
        //   this.setPriceByKey("default", price);
        // },
        onDiscountChange(event) {
            this.discount = +event.target.value

            const office = this.service.office_prices.find(
                (item) => item.id === this.office_id,
            )
            const prices = office === undefined
                ? {
                    price: 0,
                    price_fifteen: 0,
                }
                : office.prices

            this.setOffice(prices)
        },
        onPriceChanged(v) {
            const price = +v.target.value

            if (price > this.price.servicePrice) {
                this.discount = 0
                this.setPriceByKey('default', price)
                return
            }
            const discount = 1 - price / this.price.servicePrice

            this.discount = discount * 100

            this.setPriceByKey('default', price)
        },
        onConfirmResponsible({ hours, minutes }) {
            if (!this.isMultipleRequest) {
                this.formData.date = moment(this.formData.date)
                    .set('hours', hours)
                    .set('minutes', minutes)
                    .format()
            }

            this.calculatePrice()
        },
        onRemoveResponsible() {
            this.calculatePrice()
        },
        removeTag(id) {
            this.tags = this.tags.filter((item) => item.id !== id)
        },
        addTags(tags) {
            this.tags = tags
            this.closeTagsModal()
        },
        openTagsModal() {
            this.isTagsShow = true
        },
        closeTagsModal() {
            this.isTagsShow = false
        },
        toggleIsMyHammer() {
            this.isMyHammer = !this.isMyHammer
        },
        // v2 start
        preparePhone(phone) {
            return phone.replace(/\s+/g, '')
        },
        onPhoneTypingFinish() {
            if (!this.isValidPhone || this.isRequestSent) return

            this.isRequestSent = true

            setTimeout(() => {
                this.isRequestSent = false
            }, 500)

            const phone = this.preparePhone(this.contact.phone)
            this.fetchClientByPhone(phone)
        },
        async fetchClientByPhone() {
            const data = await this.getClientsData({
                word: this.contact.phone.replace(/\s+/g, ''),
            })

            this.setOrderClient(data)
        },

        setOrderClient(data) {
            const hasClients = data && data.length > 0
            setTimeout(() => {
                this.isPhoneEntered = true
            }, 300)

            if (!hasClients) {
                this.setContact({
                    phone: this.contact.phone,
                })
                this.setFormData({
                    key: 'address',
                    value: {
                        house: null,
                        street: null,
                        postcode: null,
                        city: null,
                        country: null,
                        latitude: null,
                        longitude: null,
                        apartment: null,
                    },
                })
                this.autocompleteValue = ''
                return
            }

            const client = data[0]
            const { addresses } = client
            const hasAddress = addresses && addresses.length > 0
            this.setContact(client)

            if (!hasAddress) {
                return
            }

            const address = addresses[0]
            this.setFormAddress(address)
            this.setAutocomplete()
        },

        setFormAddress(address) {
            this.setFormData({
                key: 'address',
                value: {
                    house: address.house,
                    street: address.street,
                    postcode: address.postcode,
                    city: address.city,
                    country: address.country,
                    latitude: address.latitude,
                    longitude: address.longitude,
                    apartment: address.apartment,
                },
            })
        },

        setAutocomplete() {
            if (!(this.formData.address && this.formData.address.house)) {
                return
            }

            this.autocompleteValue = `${this.formData.address.street || ''} ${this
                .formData.address.house || ''}, ${this.formData.address.postcode
        || ''}, ${this.formData.address.city || ''}`
        },
        // v2 end

        toggleRequestType(e) {
            if (this.datePickerBlurred) {
                e.preventDefault()
                return
            }

            this.isMultipleRequest = !this.isMultipleRequest
        },
        addMedia(event) {
            const files = event.target.files[0]

            if (files.size <= 50000000) {
                const typeFile = files.type.split('/')[0]
                const formData = new FormData()
                if (typeFile === 'image') {
                    if (files) {
                        const reader = new FileReader()
                        reader.readAsDataURL(files)
                        reader.onload = () => {
                            this.madiaData.push(reader.result)
                        }
                    }
                    formData.append('media', files)
                    this.formMediaData.push(formData)
                } else if (typeFile === 'video') {
                    const video = document.createElement('video')
                    video.currentTime = 10
                    const _this = this
                    video.addEventListener('loadeddata', () => {
                        const canvas = document.createElement('canvas')
                        canvas.width = this.videoWidth
                        canvas.height = this.videoHeight
                        const context = canvas.getContext('2d')
                        context.drawImage(video, 0, 0, this.videoWidth, this.videoHeight)
                        const widthConvas = this.videoWidth
                        const hightConvas = this.videoHeight
                        const img = new Image()
                        img.onload = () => {
                            const widthImg = widthConvas / 4
                            const heightImg = widthConvas / 4
                            const posX = widthConvas / 2 - widthImg / 2
                            const posY = hightConvas / 2 - heightImg / 2
                            context.drawImage(img, posX, posY, widthImg, heightImg)
                            const dataURL = canvas.toDataURL()
                            _this.madiaData.push(dataURL)
                        }
                        img.src = '/images/icon/playIcon.png'
                    })
                    video.src = window.URL.createObjectURL(files)
                    formData.append('media', files)

                    this.formMediaData.push(formData)
                }
            } else {
                this.error = true
            }
        },
        deleteMedia(i) {
            this.madiaData.splice(i, 1)
            this.formMediaData.splice(i, 1)
        },
        showResponsible() {
            this.showModalAddresponsible = !this.showModalAddresponsible
        },
        closeModal(v = '') {
            this.showModalAddresponsible = false

            if (v === 'cancel') this.responsible = []
        },
        closeModalError() {
            this.error = false
        },
        async isInValid() {
            return (await this.$validator.validate()) === false
        },
        statusIsSuccess(v) {
            return v === 201 || v === 200
        },
        setButtonDisableAttr(v) {
            this.disableButton = v
        },
        prepareFields() {
            this.formData.client_id = this.contact.id
            this.formData.landing_request_id = this.contact.request_id
            this.formData.discount = this.discount
            this.formData.source = this.isMyHammer ? 'my-hammer' : 'admin-panel'
        },
        prepareExecutors() {
            this.formData.executors = this.responsible.map((value) => value.id)
        },
        prepareDateOptions() {
            this.formData.dateOptions.value = new Date(
                this.formData.dateOptions.text,
            ).getTime()
        },
        prepareDates() {
            return this.formData.days.map((day) => moment(day).format('YYYY-MM-DD'))
        },
        prepareOrderFormat() {
            if (!this.isMultipleRequest) {
                this.formData.single = {
                    datetime: moment(this.formData.date).format('YYYY-MM-DD HH:mm'),
                    duration: this.formData.duration,
                    final_price: this.recomendedFinalPrice,
                }
            } else {
                this.formData.multi_day = {
                    final_price: this.recomendedFinalPrice,
                    dates: this.prepareDates(),
                }
            }
        },
        prepareContact() {
            this.formData.contact = {
                phone: this.contact.phone.replace(/\s+/g, ''),
                first_name: this.contact.first_name,
                last_name: this.contact.last_name,
                email: this.contact.email,
            }
        },
        clearClientId() {
            if (this.formData.client_id === '') {
                delete this.formData.client_id
            }
        },
        clearRequestId() {
            if (
                this.formData.landing_request_id === ''
        || this.formData.landing_request_id === undefined
            ) {
                delete this.formData.landing_request_id
            }
        },
        prepareTags() {
            this.formData.work_tags = this.tags.map((tag) => tag.id)
        },
        prepareForm() {
            this.setButtonDisableAttr(true)

            this.prepareExecutors()
            this.prepareDateOptions()
            this.prepareFields()
            this.prepareOrderFormat()
            this.prepareContact()
            this.prepareTags()

            this.clearClientId()
            this.clearRequestId()
            // this.formData.office_id = this.office_id;
        },
        async createRequest() {
            this.$Progress.start()
            const result = await this.addApplication({
                data: this.formData,
                media: this.formMediaData,
            })

            if (this.statusIsSuccess(result.status)) {
                this.closeShowModalAdd()
                const { title, message } = this.successNotification()

                this.$notify({
                    title,
                    message,
                    duration: 5000,
                })

                this.setSnackbarData({ id: result.data.id })
                this.setSnackbarShow(true)
                this.setUpdateCalendar()
            }

            this.fetchWithSavingScrollState()

            this.$Progress.finish()
            this.setButtonDisableAttr(false)
            this.$emit('done')
        },
        async confirm() {
            if (await this.isInValid()) {
                return
            }

            this.prepareForm()
            this.createRequest()
        },
        successNotification() {
            return {
                title: this.$t('notifications.orderCreated'),
                message: this.$t('notifications.orderCreatedText'),
            }
        },
        getServiceData(id) {
            return this.servicesFullData.find((item) => item.id === id)
        },
        async changeDate() {
            if (this.formData.isAngebot) {
                return
            }

            this.calculatePrice()
            this.setExtraPrice()
        },
        async changeService() {
            if (this.formData.isAngebot) {
                return
            }

            this.calculatePrice()
            this.setExtraPrice()

            this.service_id = this.formData.service_id
            await this.setAvailableDays()
            this.setDay()
        },
        async changeOffice() {
            if (this.formData.isAngebot) {
                return
            }

            const service = this.servicesFullData.find(
                (item) => item.id === this.formData.service_id,
            )
            const office = service.office_prices.find(
                (item) => item.id === this.formData.office_id,
            )

            const prices = office === undefined
                ? {
                    price: 0,
                    price_fifteen: 0,
                }
                : office.prices

            this.setOffice(prices)
            this.setExtraPrice()

            this.office_id = this.formData.office_id
            await this.setAvailableDays()
            this.setDay()
        },
        setOffice(office) {
            this.setPriceByKey('servicePrice', office.price)

            const officePrice = office.price + this.getPriceFromDuration(office)
            const price = this.discount ? officePrice * (1 - this.discount / 100) : officePrice

            this.setPriceByKey(
                'default',
                price,
            )
        },
        calculatePrice() {
            this.duration = this.formData.duration

            if (this.isMultipleRequest) {
                return
            }

            if (this.formData.isAngebot) {
                return
            }

            const data = this.getServiceData(this.formData.service_id)
            this.service = data

            if (this.formData.office_id) {
                const office = data.office_prices.find(
                    (item) => item.id === this.formData.office_id,
                )
                const prices = office === undefined
                    ? {
                        price: 0,
                        price_fifteen: 0,
                    }
                    : office.prices

                this.setOffice(prices)
            } else {
                console.log('not found')
                const office = data.office_prices[0].prices
                this.setOffice(office)
            }
        },
        getPriceFromDuration(data) {
            const priceFifteen = data.price_fifteen
            const value = this.formData.duration || '01:00'
            const hours = Number(value.split(':')[0]) * 60
            const minutes = Number(value.split(':')[1])
            const sum = hours + minutes
            return ((sum - 60) / 15) * priceFifteen
        },
        fillAddress(data) {
            this.formData.address.house = data.address.short_name
            this.formData.address.street = data.address.route
            this.formData.address.postcode = data.address.index
            this.formData.address.city = data.address.city
            this.formData.address.country = data.address.country

            this.formData.address.latitude = data.location.lat
            this.formData.address.longitude = data.location.lng

            this.autocompleteValue = `${this.formData.address.street || ''} ${this
                .formData.address.house || ''}, ${this.formData.address.postcode
        || ''}, ${this.formData.address.city || ''}`
        },
        openAutocomplete() {
            this.toggleAutocomplete()
        },
        checkValue(v) {
            this.isValidPhone = v.valid
        },
        onBlur() {
            this.datePickerBlurred = true
            setTimeout(() => {
                this.datePickerBlurred = false
            }, 100)
        },

        getRequestDate() {
            if (this.formData.dateOptions.text) {
                return this.formData.dateOptions.text
            } else if (this.availableDays[0]) {
                return moment(this.availableDays[0])
                    .set('minutes', 0)
                    .set('seconds', 0)
                    .set('hours', 0)
                    .format()
            } else {
                return moment()
                    .set('minutes', 0)
                    .set('seconds', 0)
                    .set('hours', 0)
                    .add(1, 'days')
                    .format()
            }
        },

        setUpOffice() {
            if (this.filteredList && this.filteredList.length > 0) {
                this.formData.office_id = this.formData.office_id
                    ? this.formData.office_id
                    : this.filteredList[0].id

                this.office_id = this.formData.office_id
            }
        },

        // INIT METHODS START
        async init() {
            this.setUpPhoneNumber()
            this.setAutocomplete()
            this.setExecutors()

            this.setUpIsEntered()
            this.setUpDuration(
                this.formData.duration ? this.formData.duration : '01:00',
            )
            this.setUpOffice()
            this.setUpServicePrice()

            if (this.formData.isAngebot) {
                this.recomendedFinalPrice = this.formData.total
                this.setPriceByKey('executorsQuantity', 1)
            }

            await this.setAvailableDays()
            this.setDay()
            this.setStatus()
        },
        setDay() {
            const requestedDate = this.getRequestDate()

            this.setUpDefaultSingleDate(requestedDate)
            this.setUpDefaultFormDays(requestedDate)
        },
        setUpDuration(v) {
            this.formData.duration = v
            this.duration = v
        },
        setUpIsEntered() {
            if (!this.contact || !this.contact.phone) {
                return
            }

            this.isPhoneEntered = true
        },
        setUpServiceSelect() {
            console.log(this.contact)
            // if (!this.contact || this.contact.type != "main") {
            //   return;
            // }

            // if (this.formData.service_id != null) return;

            // this.servicesFullData.forEach((e) => {
            //   if (e.slug == this.contact.type) {
            //     this.formData.service_id = e.id;
            //     console.log(e);
            //   }
            // });
        },
        setUpPhoneNumber() {
            if (!this.contact || !this.contact.phone) {
                return
            }

            if (this.contact.phone[0] === '4') {
                this.contact.phone = `+${this.contact.phone}`
            } else if (this.contact.phone[0] === '0') {
                this.contact.phone = `${
                    this.$config.behavior === 'hilfy' ? '43' : '49'
                }${this.contact.phone.substring(1)}`
            }
        },
        setUpServicePrice() {
            if (
                this.formData.service_id === null
        && this.servicesFullData
        && this.servicesFullData.length > 0
            ) {
                const service = this.servicesFullData[0]
                this.service = service
            } else {
                this.service = this.servicesFullData.find(
                    (item) => item.id === this.formData.service_id,
                )
            }
            this.service_id = this.service.id
            this.formData.service_id = this.service.id

            if (this.service.office_prices[0]) {
                const office = this.service.office_prices.find(
                    (item) => item.id === this.formData.office_id,
                )

                const prices = office === undefined
                    ? {
                        price: 0,
                        price_fifteen: 0,
                    }
                    : office.prices

                this.setPriceByKey('servicePrice', prices.price)
                this.setPriceByKey('default', prices.price)
                this.setPriceByKey('executorsQuantity', this.responsible.length || 1)
            }
        },
        setUpDefaultSingleDate(requestedDate) {
            this.formData.date = moment(requestedDate).format()
        },
        setUpDefaultFormDays(requestedDate) {
            this.formData.days.push(
                moment(moment(requestedDate).format('YYYY-MM-DD')).format(),
            )
        },
        setExecutors() {
            this.responsible = this.formData.executors
        },
        async setExtraPrice() {
            if (this.isMultiDays || this.formData.isAngebot) return

            const date = this.formData.date
                ? moment(this.formData.date).format('YYYY-MM-DD')
                : moment().format('YYYY-MM-DD')

            await this.fetchExtraPrice({
                service_id: this.formData.service_id,
                date,
            })

            const key = moment(this.formData.date).format('HH:mm')
            const price = this.extraPrices[key] || 0

            const percent = price === 0 ? 1 : price / 100 + 1
            this.setPriceByKey('recomended', percent)
        },
        async setStatus() {
            await this.fetchStatuses()
            this.statusesModified = this.statusesGetters.filter(
                (e) => e.status === 'confirmed' || e.status === 'stand_by',
            )
        },
    // INIT METHODS END
    },
    mounted() {
        this.init()
    },
    beforeDestroy() {
        this.setDefaultForm()
        this.setContact({})
        this.setDescription('')
    },
}
</script>

<style lang="scss" scoped>
@import "src/assets/sass/main";
</style>
